module.exports = __webpack_public_path__ + "media/images/photo07-4d979ea0b071cf1d379772f980f819d3.png";